"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPLACE_SHIPMENT_SUBCODES = exports.ReplaceShipmentResponseSubcode = exports.ShipmentReplacementException = void 0;
var ShipmentReplacementException;
(function (ShipmentReplacementException) {
    ShipmentReplacementException["CANNOT_REPLACE_ZONE_SKIP_SHIPMENT"] = "CANNOT_REPLACE_ZONE_SKIP_SHIPMENT";
    ShipmentReplacementException["HAS_ACTIVE_REPLACEMENT"] = "HAS_ACTIVE_REPLACEMENT";
    ShipmentReplacementException["MORE_THAN_ONE_PACKAGE"] = "MORE_THAN_ONE_PACKAGE";
    ShipmentReplacementException["NO_FIELDS_PROVIDED"] = "NO_FIELDS_PROVIDED";
    ShipmentReplacementException["NO_INVENTORY_AT_SAME_SC"] = "NO_INVENTORY_AT_SAME_SC";
    ShipmentReplacementException["REPLACEMENT_ALREADY_REQUESTED"] = "REPLACEMENT_ALREADY_REQUESTED";
    ShipmentReplacementException["SHIPPING_METHOD_INACTIVE"] = "SHIPPING_METHOD_INACTIVE";
    ShipmentReplacementException["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(ShipmentReplacementException = exports.ShipmentReplacementException || (exports.ShipmentReplacementException = {}));
var ReplaceShipmentResponseSubcode;
(function (ReplaceShipmentResponseSubcode) {
    ReplaceShipmentResponseSubcode["CANNOT_REPLACE_ZONE_SKIP_SHIPMENT"] = "CANNOT_REPLACE_ZONE_SKIP_SHIPMENT";
    ReplaceShipmentResponseSubcode["HAS_ACTIVE_REPLACEMENT"] = "HAS_ACTIVE_REPLACEMENT";
    ReplaceShipmentResponseSubcode["INVALID_SHIPMENT_STATE"] = "INVALID_SHIPMENT_STATE";
    ReplaceShipmentResponseSubcode["MORE_THAN_ONE_PACKAGE"] = "MORE_THAN_ONE_PACKAGE";
    ReplaceShipmentResponseSubcode["NO_INVENTORY_AT_FC"] = "NO_INVENTORY_AT_FC";
    ReplaceShipmentResponseSubcode["NO_INVENTORY_AT_SAME_SC"] = "NO_INVENTORY_AT_SAME_SC";
    ReplaceShipmentResponseSubcode["NOT_FOUND"] = "NOT_FOUND";
    ReplaceShipmentResponseSubcode["REPLACEMENT_ALREADY_REQUESTED"] = "REPLACEMENT_ALREADY_REQUESTED";
    ReplaceShipmentResponseSubcode["REPLACEMENT_CREATED"] = "REPLACEMENT_CREATED";
    ReplaceShipmentResponseSubcode["SHIPPING_METHOD_INACTIVE"] = "SHIPPING_METHOD_INACTIVE";
    ReplaceShipmentResponseSubcode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(ReplaceShipmentResponseSubcode = exports.ReplaceShipmentResponseSubcode || (exports.ReplaceShipmentResponseSubcode = {}));
exports.REPLACE_SHIPMENT_SUBCODES = Object.values(ReplaceShipmentResponseSubcode);
//# sourceMappingURL=ReplacementData.js.map